import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ChatMessage from './icon-chat-message.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ChatMessage {...validProps} />;
}
SvgComponent.iconName = 'chat-message';

/**
 * @deprecated This is a legacy icon
 */
export const ChatMessageIcon = svgIconWrapper(SvgComponent);
